const SceneIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="20" height="20" stroke="black" stroke-width="2" fill="none" rx="3"/>
            <line x1="8" y1="18" x2="16" y2="6" stroke="black" stroke-width="2"/>
        </svg>
    )
}

export default SceneIcon;